import { UserRole } from '@/types/roles';
import { useAuth } from './useAuth';

const WRITE_ROLES: ReadonlySet<string> = new Set<string>([
  UserRole.SUPER_ADMIN,
  UserRole.ORGANIZATION_ADMIN,
  UserRole.ORGANIZATION_EDITOR,
]);

/**
 * Returns true if the authenticated user holds any write-capable role
 * (`SuperAdmin`, `OrganizationAdmin`, or `OrganizationEditor`) in any of their
 * JWT-bound org memberships.
 *
 * Pure JWT read — no API call. Use for UI affordance gating like hiding the
 * "New Survey" / "New Project" buttons for Reader-only users. For "which orgs
 * can I write to" decisions (e.g. the create-x org picker), use
 * `useWriteAccessibleOrganizations` which also handles descendant propagation
 * and the SuperAdmin cross-tenant fan-out via the accessible-orgs API.
 */
export const useHasWriteRole = (): boolean => {
  const { user } = useAuth();
  return (user?.organizations ?? []).some(membership =>
    membership.roles.some(role => WRITE_ROLES.has(role))
  );
};
